import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from 'utils/api';
function teamQuery(_x, _x2) {
  return _teamQuery.apply(this, arguments);
}
function _teamQuery() {
  _teamQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, params) {
    var resp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api('get', "/api/query/".concat(path), params);
        case 2:
          resp = _context.sent;
          return _context.abrupt("return", resp);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _teamQuery.apply(this, arguments);
}
export default teamQuery;